import React from "react";
import {ListComponent} from "../../components/ListComponent";
import {Loader} from "../../components/Loader";
import {TableFooter} from "../../components/ListComponent/TableFooter";
import {FormGroup} from "../../components/FormComponent/FormGroup";
import {Dictionary} from "../../components/Dictionary";
import {Util} from "../../components/Util";
import {ShippingField} from "./ShippingField";
import {DateTime} from "../../components/ListComponent/DateTime";
import {MultiLine} from "./MultiLine";
import {Addressee} from "./Addressee";
import {ArrowDownSquareFill, InfoCircleFill} from "react-bootstrap-icons";
import {FormattedNumber} from "../../components/Elements/FormattedNumber";
import {TBody} from "../../components/Table/TBody";

export class OrderList extends ListComponent {

    protected getRequestUrl(): RequestInfo | URL {
        return '/order/list';
    }

    protected navigate(event: any) {
        if (event.target.classList.contains('copy') || event.target.closest('a')) {
            return;
        }
        event.preventDefault();
        let id = event.target.closest('tr').getAttribute('data-id');
        super.navigate(event, '/order/details/' + id);
    }

    render() {
        if (!this.state) {
            return <Loader/>;
        }

        const navigate = this.navigate, params: {} | any = this.getFormData();

        const searchBarClassList = window.location.hash ? 'search-bar' : 'search-bar hidden';
        const dictionary: Dictionary = this.dictionary;
        const statuses = this.state?.item?.statuses || [];

        return (
            <>
                <div className="row">
                    <h5 className="open-search">
                        {this.dictionary.get['search']}
                        <span onClick={this.toggleSearchBar} style={{
                            cursor: 'pointer',
                            fontWeight: 'normal',
                            paddingLeft: '20px',
                            fontSize: '13px'
                        }}><ArrowDownSquareFill/> {this.dictionary.get['detailed-search']}</span>
                    </h5>

                    <form className="x-form" method="POST" onSubmit={this.handleSubmit}>
                        <div className={searchBarClassList}>
                            <div className="row">

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'search', defaultValue: params?.search}}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'id', defaultValue: params?.id}}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{id: 'sku', defaultValue: params?.sku}}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Input {...{
                                        id: 'shipping_country',
                                        defaultValue: params?.shipping_country
                                    }}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Select {...{
                                        id: 'status',
                                        basic: 'show-all',
                                        items: ['draft', 'scheduled', 'open', 'in-transit', 'closed', 'cancelled', 'insufficient-quantity', 'error', 'b2b-in-transit', 'b2b-open', 'completed', 'close-error', 'address-error', 'sync-error', 'create-error', 'unknown-product', 'customer-error', 'duplication-error', 'import-error', 'on-hold', 'archived'],
                                        defaultValue: params?.status
                                    }}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Select {...{
                                        id: 'type',
                                        basic: 'show-all',
                                        items: ['B2C', 'B2B'],
                                        defaultValue: params?.type
                                    }}/>
                                </div>

                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Select {...{
                                        id: 'incomplete',
                                        basic: 'show-all',
                                        items: ['yes', 'no', 'no-info'],
                                        defaultValue: params?.incomplete
                                    }}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.Select {...{
                                        id: 'relationships',
                                        basic: 'show-all',
                                        items: ['has-parent', 'no-parent'],//,  'has-children','no-children'],
                                        defaultValue: params?.relationships
                                    }}/>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'created_from', defaultValue: params?.created_from}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'created_to', defaultValue: params?.created_to}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{
                                        id: 'imported_from',
                                        defaultValue: params?.imported_from
                                    }}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'imported_to', defaultValue: params?.imported_to}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'closed_from', defaultValue: params?.closed_from}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{id: 'closed_to', defaultValue: params?.closed_to}}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{
                                        id: 'scheduled_from',
                                        defaultValue: params?.scheduled_from
                                    }}/>
                                </div>
                                <div className="col-md-6 col-lg-4 col-xl-3">
                                    <FormGroup.DateTime {...{
                                        id: 'scheduled_to',
                                        defaultValue: params?.scheduled_to,
                                        label: 'scheduled_to_to'
                                    }}/>
                                </div>
                            </div>
                        </div>

                        <input type="hidden" name="sort" defaultValue={params.sort ?? 'id:d'}/>

                        {this.listOfSearchParams(params)}

                        <div className="row">
                            <div className="col-12 caption">
                                <button className="btn btn-sm btn-primary" type="submit">
                                    {this.dictionary.get['search']}
                                </button>
                                &nbsp;
                                <button className="btn btn-sm btn-light"
                                        onClick={((event: MouseEvent | any) => {
                                            event.preventDefault();
                                            this.exportTableData('/order/list-export')
                                        })}>
                                    {this.dictionary.get['export']}
                                </button>
                                &nbsp;
                                &nbsp;
                                <h6>
                                    {this.dictionary.get['orders']}: &nbsp;
                                    {this.state.count ? this.state.count : '-'} {this.dictionary.get['pc']}
                                </h6>
                            </div>
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>
                            {statuses.map(function (elem: any) {
                                return (
                                    <div className="col-6 col-sm-6 col-md-4 col-xl-3 col-xxl-2" key={TBody.index++}>
                                        {Util.searchStatus(elem.status, {
                                            style: {
                                                fontSize: '11px',
                                                fontWeight: 'normal'
                                            }
                                        })}
                                        &nbsp;<FormattedNumber value={elem.count}/>
                                        &nbsp;{dictionary.get['pc']}
                                    </div>);
                            })}
                        </div>
                        <div className="row" style={{marginBottom: '10px'}}>
                            <div className="col-12 col-sm-12 col-md-4" key={TBody.index++}>
                                <InfoCircleFill
                                    style={{margin: '-3px 0 0 0', color: '#3366FF'}}/> {dictionary.get['item_count']}:
                                &nbsp;<FormattedNumber value={this.state?.item?.counts?.item_count}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-12 col-md-4" key={TBody.index++}>
                                <InfoCircleFill
                                    style={{margin: '-3px 0 0 0', color: '#3366FF'}}/> {dictionary.get['product_count']}:
                                &nbsp;<FormattedNumber value={this.state?.item?.counts?.product_count}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                            <div className="col-12 col-sm-12 col-md-4" key={TBody.index++}>
                                <InfoCircleFill
                                    style={{margin: '-3px 0 0 0', color: '#3366FF'}}/> {dictionary.get['shipped_count']}:
                                &nbsp;<FormattedNumber value={this.state?.item?.counts?.shipped_count}/>
                                &nbsp;{dictionary.get['pc']}
                            </div>
                        </div>
                    </form>
                </div>

                <div className="row">
                    <div className="table-responsive">
                        <table className="table table-hover table-sm align-middle">
                            <thead>
                            <tr>
                                <th className="sortable" data-sortkey="o.id">
                                    #ID<i className="bi bi-sort-down"></i>
                                </th>
                                <th className="sortable" data-sortkey="o.`reference_no`">
                                    RNO
                                </th>
                                <th className="sortable" data-sortkey="o.`reference_name`">
                                    RNE
                                </th>
                                <th className="sortable" data-sortkey="o.`fulfillment_id`">
                                    FID / QID
                                </th>
                                <th className="sortable" data-sortkey="o.`status`">{this.dictionary.get['status']}</th>
                                <th className="sortable"
                                    data-sortkey="o.`item_count`">{this.dictionary.get['item_count']}</th>
                                <th className="sortable"
                                    data-sortkey="o.`product_count`">{this.dictionary.get['product_count']}</th>
                                <th className="sortable"
                                    data-sortkey="o.`shipped_count`">{this.dictionary.get['shipped_count']}</th>
                                <th className="sortable"
                                    data-sortkey="o.`order_volume`">{this.dictionary.get['order_volume']}</th>
                                <th className="sortable" data-sortkey="o.`type`">{this.dictionary.get['type']}</th>
                                <th className="sortable"
                                    data-sortkey="o.`total_amount`">{this.dictionary.get['total_amount']}</th>
                                <th className="sortable"
                                    data-sortkey="o.`cod_amount`">{this.dictionary.get['cod_amount']}</th>
                                <th className="">{this.dictionary.get['shipping']}</th>
                                <th className="">{this.dictionary.get['addressee']}</th>
                                <th className="">AWB/SNO</th>
                                <th className="sortable" data-sortkey="o.created_at">
                                    {this.dictionary.get['created_at']}
                                </th>
                                <th className="sortable" data-sortkey="o.imported_at">
                                    {this.dictionary.get['imported_at']}
                                </th>
                                <th className="sortable" data-sortkey="o.scheduled_to">
                                    {this.dictionary.get['scheduled_to']}
                                </th>
                                <th className="sortable" data-sortkey="o.fulfillment_imported_at">
                                    {this.dictionary.get['fulfillment_imported_at']}
                                </th>
                                <th className="sortable" data-sortkey="o.picking_start_at">
                                    {this.dictionary.get['picking_start_at']}
                                </th>
                                <th className="sortable" data-sortkey="o.picking_end_at">
                                    {this.dictionary.get['picking_end_at']}
                                </th>
                                <th className="sortable" data-sortkey="o.packing_end_at">
                                    {this.dictionary.get['packing_end_at']}
                                </th>
                                <th className="sortable" data-sortkey="o.manifest_date">
                                    {this.dictionary.get['manifest_date']}
                                </th>
                                <th className="sortable" data-sortkey="o.closed_at">
                                    {this.dictionary.get['closed_at']}
                                </th>
                                <th>
                                    {this.dictionary.get['nfo']}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.state.items.map(function (elem: any) {
                                let totalAmount = Dictionary.PriceFormat(elem.total_amount, elem.total_currency);
                                let codAmount = Dictionary.PriceFormat(elem.cod_amount, elem.cod_currency);

                                let fulfillmentId = '', copyFulfillmentId = elem.fulfillment_id;
                                if (elem.fulfillment_id) {
                                    fulfillmentId = 'FID: ' + elem.fulfillment_id;
                                } else {
                                    copyFulfillmentId = elem.queue_id;
                                }
                                if (elem.queue_id) {
                                    elem.queue_id = 'QID: ' + elem.queue_id;
                                }
                                let trackingList: string[] = [];

                                elem.tracking_no && trackingList.push(elem.tracking_no);
                                elem.shipment_no && trackingList.push(elem.shipment_no);

                                return (
                                    <tr key={elem.id} data-id={elem.id} onMouseDown={navigate}>
                                        <td className="copy" onClick={Util.copy} data-copy={elem.id}
                                            style={{textAlign: 'right'}}>{elem.id}.&nbsp;</td>
                                        <td className="copy" onClick={Util.copy}>{elem.reference_no}</td>
                                        <td className="copy" onClick={Util.copy}>{elem.reference_name}</td>
                                        <td className="copy" onClick={Util.copy} data-copy={copyFulfillmentId}>
                                            {fulfillmentId} <br/> {elem.queue_id}
                                        </td>
                                        {Util.status(elem.status, {parentNode: 'td', style: {fontSize: '11px'}})}
                                        <td><FormattedNumber value={elem.item_count} suffix={dictionary.get['pc']}/>
                                        </td>
                                        <td><FormattedNumber value={elem.product_count} suffix={dictionary.get['pc']}/>
                                        </td>
                                        <td><FormattedNumber value={elem.shipped_count} suffix={dictionary.get['pc']}/>
                                        </td>
                                        <td><FormattedNumber value={elem.order_volume} suffix={'m3'} decimals={3}/>
                                        </td>
                                        <td>{elem.type}</td>
                                        <td>{totalAmount}</td>
                                        <td>{codAmount}</td>
                                        <td><ShippingField {...elem}/></td>
                                        <td><Addressee {...elem}/></td>
                                        <td><MultiLine items={trackingList}/></td>
                                        <td><DateTime value={elem.created_at}/></td>
                                        <td><DateTime value={elem.imported_at}/></td>
                                        <td><DateTime value={elem.scheduled_to}/></td>
                                        <td><DateTime value={elem.fulfillment_imported_at}/></td>
                                        <td><DateTime value={elem.picking_start_at}/></td>
                                        <td><DateTime value={elem.picking_end_at}/></td>
                                        <td><DateTime value={elem.packing_end_at}/></td>
                                        <td><DateTime value={elem.manifest_date}/></td>
                                        <td><DateTime value={elem.closed_at}/></td>
                                        <td>{elem.nfo}</td>
                                    </tr>
                                )
                            })}
                            </tbody>
                            {this.state.itemsCount < this.limit ? (
                                <TableFooter colspan={18}/>
                            ) : ''}
                        </table>
                        {this.state.isLoading && <Loader/>}
                    </div>
                </div>
            </>
        );
    }
}
